import React, { useEffect } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import FormInput from '../../../components/form/FormInput';
import FormToggle from '../../../components/form/FormToggle';

import { dncUpdate, dncAdd } from '../../../store/slices/tenantSlices/incomingSlice';

const AddEditDncModal = ({ isOpen, onCloseClick, isEdit = false, editRecord = null }) => {
  const dispatch = useDispatch();

  const initialValues = {
    phonenumber: '',
    active: 'true'
  };

  const validationSchema = Yup.object({
    phonenumber: Yup.string()
      .required('Phone number is required')
      .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
  });

  const onSubmit = async () => {
    if (isEdit) {
      try {
        const payload = { ...values, id: editRecord.id };
        const response = await dispatch(dncUpdate(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Updated Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      try {
        const payload = { ...values };
        const response = await dispatch(dncAdd(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Added Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...values,
        phonenumber: editRecord?.phoneNumber,
        active: String(editRecord?.active)
      });
    }
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{isEdit ? 'Edit DNC' : 'Add DNC'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="dnc" onSubmit={handleSubmit}>
          <Row>
            <Col lg="3">
              <FormInput
                name="phonenumber"
                label="Phone Number"
                placeholder="Enter phone number"
                value={values.phonenumber}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormToggle
                name="active"
                label="Active"
                value={values.active}
                onChange={(e) => setFieldValue('active', e)}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="dnc" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditDncModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditDncModal;
